import { render, staticRenderFns } from "./PoleStarProjectsDetails.vue?vue&type=template&id=ceff48da&"
import script from "./PoleStarProjectsDetails.vue?vue&type=script&lang=js&"
export * from "./PoleStarProjectsDetails.vue?vue&type=script&lang=js&"
import style0 from "./PoleStarProjectsDetails.vue?vue&type=style&index=0&id=ceff48da&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports